import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";

const EditNiosAssignmentPricing = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();
  const [niosClass, setNiosClass] = useState([]);
  const [niosClassId, setNiosClassId] = useState();
  const [niosSubject, setNiosSubject] = useState([]);
  const [niosSubjectId, setNiosSubjectId] = useState();
  const [price, setPrice] = useState();
  const { id } = useParams();

  const handleAddNiosPricing = () => {
    navigate("/assignment-pricing/add-nios-assignment-pricing");
  };
  const handleViewAllNiosPricing = () => {
    navigate("/assignment-pricing/all-nios-assignment-pricing");
  };
  const handleGoBack = () => {
    navigate("/assignment-pricing");
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/pricing/assignment/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        console.log(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/niosClasses`)
      .then((resp) => {
        const { data } = resp;
        // console.log(resp.data);
        // console.log(data);
        setNiosClass(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // Fetch subjects based on selected class name
  useEffect(() => {
    if (niosClassId) {
      axios
        .get(`${API_BASE_URL}/niosSubjects?classId=${niosClassId}`)
        .then((result) => {
          const { data } = result;
          setNiosSubject(data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [niosClassId]);

  const payload = {
    niosSubjectId,
    price,
    type: "nios",
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .put(`${API_BASE_URL}/admin/pricing/assignment/${id}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        console.log(result);
        alert("Nios assignment pricing updated successfully.");
      })
      .catch((error) => {
        console.log(error);
        alert("Error while updating nios assignment pricing.");
      });
  };

  return (
    <div id="exam-school-notes-inner-wrapper">
      <div className="main-header">
        <BiArrowBack
          onClick={handleGoBack}
          className="left-arrow-icon"
          style={{
            cursor: "pointer",
            display: "flex",
            fontSize: "25px",
            color: "#000",
          }}
        />
        <div className="exam-header-div">
          <h5>Nios Assignment Pricing</h5>
          <div className="exam-btn-group">
            <button className="addNewNoteBtn" onClick={handleAddNiosPricing}>
              + Add Nios Pricing
            </button>
            <button
              className="viewAllNotesBtn"
              onClick={handleViewAllNiosPricing}
            >
              All Pricing
            </button>
          </div>
        </div>

        <div className="form-container" id="form">
          <h4 className="note-detail">Update Nios Assignment Price</h4>
          <form onSubmit={handleSubmit} className="note-detail-form">
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Class Name</label>
              </div>
              <select
                className="select-dropdown"
                value={niosClassId}
                onChange={(e) => setNiosClassId(e.target.value)}
                required
              >
                <option value="">-Select Class-</option>
                {niosClass &&
                  niosClass.map((classes) => (
                    <option value={classes._id} key={classes._id}>
                      {classes?.className}
                    </option>
                  ))}
              </select>
            </div>

            <div className="new-chapter-form-group">
              <label className="new-chapter-label">Subject Name</label>
              <select
                className="new-chapter-dropdown"
                value={niosSubjectId}
                onChange={(e) => setNiosSubjectId(e.target.value)}
                required
              >
                <option value="">-Select Subject-</option>
                {niosSubject.map((subject, idx) => (
                  <option key={idx} value={subject._id}>
                    {subject.subjectName}
                  </option>
                ))}
              </select>
            </div>

            <div className="input-group">
              <label className="label">Price</label>
              <input
                type="text"
                className=""
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                placeholder="Enter Price"
                required
              />
            </div>

            <div className="form1-btns">
              <button className="btn-save">Save</button>
              <button
                type="button"
                className="btn-cancel"
                onClick={handleGoBack}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditNiosAssignmentPricing;
